<template>
  <div>
    <div class="card secondary padding-lg margin-bottom-lg text-left">
      <template v-if="hasPerpetualLicense">
        <h3 class="size-md margin-bottom-2xs">Your perpetual license is forever.</h3>
        <p class="margin-bottom-0">You keep every icon released while your subscription was active. Even after you cancel.</p>
      </template>
      <template v-else>
        <h3 class="size-md margin-bottom-2xs">This plan doesn't include a perpetual license.</h3>
        <p class="margin-bottom-0">Pro icons stay licensed only while your subscription is active.</p>
      </template>
    </div>

    <p
      v-if="endsImmediately"
      class="margin-bottom-md"
    >
      Your subscription has an unpaid renewal. Canceling ends it right away, and we won't try to collect that payment. You will lose access to:
    </p>
    <p
      v-else
      class="margin-bottom-md"
    >
      You will continue to have access to icons, kits, and services {{ untilPhrase }}. After that you will lose access to:
    </p>

    <ul
      class="margin-bottom-0"
      style="--list-style-type: none; --list-padding-left: 0"
    >
      <li
        v-if="!hasPerpetualLicense"
        class="display-flex flex-items-start padding-vertical-sm"
      >
        <font-awesome-icon
          :icon="$v7.solid.faFileCertificate"
          size="xl"
        />
        <span class="margin-left-lg"> Your license to use Pro icons </span>
      </li>
      <li class="display-flex flex-items-start padding-vertical-sm">
        <font-awesome-icon
          :icon="$v7.solid.faParachuteBox"
          size="xl"
        />
        <span class="margin-left-lg">New icons, styles, and updates</span>
      </li>
      <li class="display-flex flex-items-start padding-vertical-sm">
        <font-awesome-icon
          :icon="$v7.solid.faWrench"
          size="xl"
        />
        <span class="margin-left-lg">Software updates and fixes</span>
      </li>
      <li class="display-flex flex-items-start padding-vertical-sm">
        <font-awesome-icon
          :icon="$v7.solid.faToolbox"
          size="xl"
        />
        <span class="margin-left-lg">Kits, CDN, NPM, and other services</span>
      </li>
      <li class="display-flex flex-items-start padding-vertical-sm">
        <font-awesome-icon
          :icon="$v7.solid.faUserHeadset"
          size="xl"
        />
        <span class="margin-left-lg">
          Actual Human<span
            aria-label='No, "Actual Human" isn&apos;t really trademarked. But we will get you unstuck so you can get back to work.'
            data-balloon-pos="up"
            data-balloon-length="xlarge"
          >
            <font-awesome-icon
              :icon="$v7.regular.faTrademark"
              size="sm"
              transform="shrink-4 up-4 left-2"
            />
          </span>
          support
        </span>
      </li>
    </ul>

    <div
      v-if="cancelError"
      class="card padding-md margin-top-lg"
      role="alert"
    >
      <p class="size-sm margin-bottom-sm">Something went wrong while canceling. Please try again.</p>
      <a
        :href="contactSupportHref"
        class="size-sm"
      >
        Contact support
      </a>
    </div>
  </div>
</template>

<script>
  import { buildSupportMailto } from 'app/utils/cancellationSupportEmail'

  export default {
    name: 'ScreenConfirmCancellation',

    props: {
      subscriptionEndDate: {
        type: String,
        default: ''
      },
      accountEmail: {
        type: String,
        default: ''
      },
      planName: {
        type: String,
        default: ''
      },
      hasPerpetualLicense: {
        type: Boolean,
        default: false
      },
      endsImmediately: {
        type: Boolean,
        default: false
      },
      cancelError: {
        type: Error,
        default: null
      }
    },

    computed: {
      untilPhrase() {
        return this.subscriptionEndDate ? `until ${this.subscriptionEndDate}` : 'until your current billing period ends'
      },

      contactSupportHref() {
        return buildSupportMailto({
          accountEmail: this.accountEmail,
          planName: this.planName,
          subscriptionEndDate: this.subscriptionEndDate,
          reason: 'cancel_failed'
        })
      }
    }
  }
</script>
